import { el, setChildren, setAttr } from 'redom';

import { buildButtonAttributes } from './utilities';

import './index.scss';

class DeleteActionButton {

  constructor(configuration) {

    this.onClick = configuration.onClick;
    this.label = el('label', configuration.label || 'Delete');

    this.el = el('button', {
      ...buildButtonAttributes(configuration),
      onclick: this.handleClick.bind(this)
    }, this.label);

  }

  setWorking() {

    setChildren(this.el, [el('ht-spinner', { size: 'small' })]);
    setAttr(this.el, {
      disabled: true
    });

  }

  setIdle() {

    setChildren(this.el, [this.label]);
    setAttr(this.el, {
      disabled: false
    });

  }

  async handleClick(event) {

    this.setWorking();

    await this.onClick(event);

    this.setIdle();

  }

}

export default DeleteActionButton;